import { rankingItems } from '@/mocks/homeData';

export default function RankingSection() {
  const trendIcon = (trend: string) => {
    if (trend === 'up') return { icon: 'ri-arrow-up-fill', cls: 'text-primary-500' };
    if (trend === 'new') return { icon: 'ri-sparkling-fill', cls: 'text-accent-500' };
    return { icon: 'ri-subtract-line', cls: 'text-foreground-400' };
  };

  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900">
            热播榜单
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500">
            51影院实时热播排行，看看大家都在追什么
          </p>
        </div>
        <div className="space-y-2 md:space-y-3">
          {rankingItems.map((item) => {
            const ti = trendIcon(item.trend);
            return (
              <a
                key={item.rank}
                href="#cards"
                onClick={(e) => { e.preventDefault(); document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="flex items-center gap-3 md:gap-4 p-3 md:p-4 rounded-2xl bg-background-100 hover:bg-background-200 transition-colors duration-200 group cursor-pointer"
              >
                <span
                  className={`flex-shrink-0 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-xl font-heading font-bold text-sm md:text-base ${
                    item.rank <= 3
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-300 text-foreground-600'
                  }`}
                >
                  {item.rank}
                </span>
                <div className="flex-1 min-w-0">
                  <div className="font-heading text-sm md:text-base font-semibold text-foreground-800 truncate group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </div>
                </div>
                <span className="flex-shrink-0 px-2 py-0.5 rounded-full text-xs font-medium bg-secondary-100 text-secondary-600 whitespace-nowrap">
                  {item.tag}
                </span>
                <span className="flex-shrink-0 text-xs md:text-sm text-foreground-500 whitespace-nowrap">
                  {item.hot}热度
                </span>
                <span className={`flex-shrink-0 w-5 h-5 flex items-center justify-center ${ti.cls}`}>
                  <i className={ti.icon}></i>
                </span>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}